import * as Config from '../../../config';
import React from 'react';
import { Switch, Route, Redirect } from "react-router-dom";
import { useDispatch } from 'react-redux';

import PlaylistRoom from './PlaylistRoom';
import useNoConnected from './hooks/useNoConnected';
import ModalCTA from '../modal/ModalCTA';
import ModalButton from '../modal/ModalButton';

import { setModal } from "../../../actions/index";
import { setDevPM } from "./redux/actions/index";

function PartyModeRoute() {
  const dispatch = useDispatch();
  useNoConnected();
  return (
    <Switch>
      <Route path="/pm/:type/:owner/:id/:token" render={ props => {
        if (navigator.userAgent.match(/Mobile|Windows Phone/i)) {
          localStorage.removeItem('a5RAW%93W!gph8');
          localStorage.removeItem('invit_pm');
          dispatch(setModal({
            content: (
              <ModalCTA
                id={`mobile-restriction-pm`}
                title={`Sorry, ${Config.capAppName()} DJ is currently desktop only.`}
                description={`For best experience open this link on a desktop Chrome browser.`}
                styleContainer={{marginTop: `-100%`, marginLeft: `-150%`}}
                classModal={`mobile`}
                styleBody={{gap: 26}}
                cancelClick={() => {}}
              >
                <ModalButton label={`Close`} className={`primary`} />
              </ModalCTA>
            ),
            underlayClickExits: false,
            underlayBackground: `rgba(18, 18, 18, 1)`
          }));
        } else {
          if (window.compact_toggle && window.compact_mode_enable) { window.compact_toggle(); }
          localStorage.removeItem('a5RAW%93W!gph8'); // Each time the link is used, re-invite
          localStorage.setItem('invit_pm', JSON.stringify({
            active: (props.match.params.type === 'dj'),
            owner: props.match.params.owner,
            id: props.match.params.id, // Room ID
            token: props.match.params.token
          }));
        }
        return <Redirect to="/home" />
      }} />
      <Route path="/session-playlist">
        <PlaylistRoom id={Config.UID_SHARED_PLAYLIST} title={`Set playlist`}
          allowSaving={true} sortable={false} listType={`Full`}
        />
      </Route>
      <Route path="/queue-playlist">
        <PlaylistRoom id={Config.UID_SUGGESTED_PLAYLIST} title={`REQUESTS`}
          allowSaving={true} sortable={false} listType={`Shared`}
        />
      </Route>
      <Route path="/pm/session/dev" render={ props => {
        dispatch(setDevPM(true))
        return <Redirect to="/home" />
      }} />
    </Switch>
  );
}

export default PartyModeRoute;
